import styles from "./NoPage.module.css";
import ServiceNSWLogo from "../assets/serviceNSWLogo";
import { ActionButton } from "../components/ActionButton";
import { Info24Regular } from "@fluentui/react-icons";

const NoPage = () => {
  const handleClose = () => {
    window.close(); // works for pop-ups
    window.location.href = "/"; // graceful fallback
  };

  return (
    <main className={styles.wrapper}>
      {/* ─── Fixed header ─────────────────────────────── */}
      <header className={styles.chatHeader}>
        <div className={styles.chatHeaderMenu}>
          <ServiceNSWLogo w={"123"} h={"63"} />
        </div>
      </header>

      {/* ─── Grey banner ──────────────────────────────── */}
      <section className={styles.band}>
        <div className={styles.content}>
          <h1 className={styles.heading}>We’re sorry about this…</h1>

          <div className={styles.messageBox} role="alert">
            <Info24Regular className={styles.messageIcon} aria-hidden />
            <p className={styles.messageText}>
              The page you’re looking for has been moved or no longer exists.
              <br />
              We’ll investigate why this happened.
            </p>
          </div>
        </div>
      </section>

      {/* ─── Action button ────────────────────────────── */}
      <ActionButton className={styles.closeBtn} onClick={handleClose}>
        Close window
      </ActionButton>
    </main>
  );
};

export default NoPage;
